import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=4ceac4e8&scoped=true&"
import script from "./SystemSetting.vue?vue&type=script&lang=js&"
export * from "./SystemSetting.vue?vue&type=script&lang=js&"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=4ceac4e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceac4e8",
  null
  
)

export default component.exports